import React, { useState, useRef, useEffect } from 'react';

interface TabProps {
  label: string;
  children: React.ReactNode;
}

const Tab: React.FC<TabProps> = ({ children }) => {
  return <div className="p-1">{children}</div>;
};

interface GearTabProps {
  children: React.ReactElement<TabProps>[];
}

const GearTab: React.FC<GearTabProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [contentHeight, setContentHeight] = useState<number>(0);
  const contentRef = useRef<HTMLDivElement>(null);

  const updateHeight = () => {
    if (contentRef.current) {
      const height = contentRef.current.scrollHeight;
      setContentHeight(height);
    }
  };

  useEffect(() => {
    // Calcola l'altezza quando cambia il tab attivo
    // Usa un piccolo delay per assicurarsi che il DOM sia aggiornato
    const timeoutId = setTimeout(() => {
      updateHeight();
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [activeTab]);

  useEffect(() => {
    // Calcola l'altezza iniziale quando il componente viene montato
    updateHeight();
    
    // Usa ResizeObserver per rilevare cambiamenti dinamici nel contenuto
    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });

    const currentRef = contentRef.current;
    if (currentRef) {
      resizeObserver.observe(currentRef);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [activeTab]);

  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className="w-full">
      <div className="h-[36px] p-[3px] bg-items rounded-full">
        <nav className="flex h-full" aria-label="Tabs">
          {children.map((child, index) => (
            <button
              key={child.props.label}
              onClick={() => handleTabChange(index)}
              style={{boxShadow: 'none'}}
              className={`
                whitespace-nowrap px-1 flex-1 rounded-full text-white font-[400] text-[14px] h-full shadow-none
                ${index === activeTab
                  ? 'bg-items-light'
                  : ''
                }
              `}
            >
              {child.props.label}
            </button>
          ))}
        </nav>
      </div>
      <div 
        className="mt-2 overflow-hidden transition-all duration-300 ease-in-out"
        style={{ height: `${contentHeight}px` }}
      >
        <div ref={contentRef}>
          {children[activeTab]}
        </div>
      </div>
    </div>
  );
};

export { GearTab, Tab };
